import * as Swal from "sweetalert2";
import swal from "sweetalert2";
const title = '¿Desea salir de la pantalla?';
const sePerderanLosCambios = 'Se perderán los cambios que ha realizado';

function preguntarSiDeseaSalirSinGuardar(){
    return new Promise((resolve) => {
        Swal.fire({
            title: title,
            text: sePerderanLosCambios,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Salir sin Guardar',
            cancelButtonText: 'Seguir Modificando'
        }).then((result) => {
            if (result.value) {
                resolve(true);
            }else{
                resolve(false);
            }
        })
    });
}


function atenederBotonPanico(){
    return new Promise((resolve) => {
        Swal.fire({
            title: '¡Botón de Pánico Detectado!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ir a revisar',
            cancelButtonText: 'Posponer'
        }).then((result) => {
            if (result.value) {
                resolve(true);
            }else{
                resolve(false);
            }
        })
    });
}

function inputCartaPorte(title){
    return new Promise((resolve) => {
        Swal.fire({
            title: title,
            input: 'number',
            showCancelButton: true,
            inputAttributes: {
                min: 0,
                max: 999999
             }
        }).then((result) => {
            if(result) {
                resolve(result.value);
            }
        })
    });
}

function inputNumero(title,min,max){
    return new Promise((resolve) => {
        Swal.fire({
            title: title,
            input: 'number',
            showCancelButton: true,
            inputAttributes: {
                min: min ?? 0,
                max: max ?? 99999
             }
        }).then((result) => {
            if(result) {
                resolve(result.value);
            }
        })
    });
}

function preguntarSiNo(pregunta){
    return new Promise((resolve) => {
        Swal.fire({
            title: pregunta,
            //text: sePerderanLosCambios,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.value) {
                resolve(true);
            }else{
                resolve(false);
            }
        })
    });
}

function preguntarSiNoAdvertencia(pregunta){
    return new Promise((resolve) => {
        Swal.fire({
            title: pregunta,
            //text: sePerderanLosCambios,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.value) {
                resolve(true);
            }else{
                resolve(false);
            }
        })
    });
}

function seleccionarCotizacion() {
    swal.fire({
        titleText: 'Aviso',
        text: 'Debe seleccionar una cotización.',
        type: 'warning',
    });
}

function seleccionarRuta() {
    swal.fire({
        titleText: 'Aviso',
        text: 'Debe seleccionar una ruta.',
        type: 'warning',
    });
}

function aviso(mensaje) {
    swal.fire({
        titleText: 'Aviso',
        text: mensaje,
        type: 'warning',
    });
}

function informacion(mensaje) {
    swal.fire({
        titleText: 'Aviso',
        text: mensaje,
        icon: 'info',
    });
}
function erroresTimbrado(errores = []) {
    const lista = Array.isArray(errores) ? errores : [errores];

    const html = lista.map(error => `
        <div style="
            text-align: left;
            border: 1px solid #e5e7eb;
            border-left: 5px solid #d32f2f;
            border-radius: 8px;
            padding: 16px;
            margin-bottom: 14px;
            background: #ffffff;
        ">
            <div style="
                color: #d32f2f;
                font-size: 18px;
                font-weight: 700;
                margin-bottom: 8px;
            ">
                ${error.codigo
                    ? `${error.codigo} - ${error.titulo}`
                    : error.titulo}
            </div>

            <div style="
                color: #374151;
                font-size: 16px;
                line-height: 1.5;
            ">
                ${error.mensajeUsuario}
            </div>

            ${
                error.solucion
                    ? `
                        <div style="
                            margin-top: 12px;
                            padding: 12px;
                            border-radius: 6px;
                            background: #eff6ff;
                            color: #1e3a8a;
                        ">
                            <strong>Solución:</strong><br />
                            ${error.solucion}
                        </div>
                    `
                    : ""
            }
        </div>
    `).join("");

    return swal.fire({
        icon: "error",
        titleText: "No fue posible timbrar",
        html,
        width: 700,
        confirmButtonText: "Entendido"
    });
}
function seleccionarServicio() {
    return new Promise((resolve) => {
        Swal.fire({
            title: 'Seleccione el servicio',
            text: '¿Qué tipo de solicitud desea generar?',
            icon: 'question',

            input: 'select',

            inputOptions: {
                rescate: 'Rescate',
                diesel: 'Solicitud de diesel',
                atencionPatio: 'Atención en Patios'
            },

            inputPlaceholder: 'Seleccione una opción',

            showCancelButton: true,
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Cancelar',

            confirmButtonColor: '#2563eb',
            cancelButtonColor: '#6b7280',

            inputValidator: (value) => {
                if (!value) {
                    return 'Debe seleccionar un servicio';
                }

                return undefined;
            }
        }).then((result) => {
            if (result.value) {
                resolve(result.value);
                return;
            }

            resolve(null);
        });
    });
}
const alerts = {
    preguntarSiDeseaSalirSinGuardar,
    seleccionarCotizacion,
    seleccionarRuta,
    aviso,
    preguntarSiNo,
    preguntarSiNoAdvertencia,
    inputCartaPorte,
    inputNumero,
    informacion,
    atenederBotonPanico,
    seleccionarServicio,
    erroresTimbrado
};
export default alerts;